import { render, staticRenderFns } from "./SearchRefs.vue?vue&type=template&id=7327cbd6&"
import script from "./SearchRefs.vue?vue&type=script&lang=js&"
export * from "./SearchRefs.vue?vue&type=script&lang=js&"
import style0 from "./SearchRefs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports